export const parentListApi = [
    {
        "id": 101,
        "title": "Golwire small"
    },
    {
        "id": 102,
        "title": "Golwire Medium"
    },
    {
        "id": 103,
        "title": "1MM"
    },
    {
        "id": 104,
        "title": "1.5MM"
    },
    {
        "id": 105,
        "title": "2MM"
    },
    {
        "id": 106,
        "title": "2.5MM"
    },
    {
        "id": 107,
        "title": "3MM"
    },
    {
        "id": 108,
        "title": "3.5MM"
    },
    {
        "id": 109,
        "title": "4MM"
    },
    {
        "id": 110,
        "title": "4.5MM"
    },
    {
        "id": 111,
        "title": "5MM"
    },
    {
        "id": 112,
        "title": "5.2MM"
    },
    {
        "id": 113,
        "title": "5/3MM"
    },
    {
        "id": 114,
        "title": "5.5MM"
    },
    {
        "id": 115,
        "title": "6MM"
    },
    {
        "id": 116,
        "title": "6.2MM"
    },
    {
        "id": 117,
        "title": "6/3MM"
    },
    {
        "id": 118,
        "title": "6.5MM"
    },
    {
        "id": 119,
        "title": "7MM"
    },
    {
        "id": 120,
        "title": "7.2MM"
    },
    {
        "id": 121,
        "title": "7/3MM"
    },
    {
        "id": 122,
        "title": "7.8MM"
    },
    {
        "id": 123,
        "title": "8MM"
    },
    {
        "id": 124,
        "title": "8/3MM"
    },
    {
        "id": 125,
        "title": "8.5MM"
    },
    {
        "id": 126,
        "title": "9MM"
    },
    {
        "id": 127,
        "title": "9.2MM"
    },
    {
        "id": 128,
        "title": "9/3MM"
    },
    {
        "id": 129,
        "title": "10MM"
    },
    {
        "id": 130,
        "title": "10/3MM"
    },
    {
        "id": 131,
        "title": "11MM"
    },
    {
        "id": 132,
        "title": "11/3MM"
    },
    {
        "id": 133,
        "title": "11/4MM"
    },
    {
        "id": 134,
        "title": "11/5MM"
    },
    {
        "id": 135,
        "title": "12MM"
    },
    {
        "id": 136,
        "title": "12/3MM"
    },
    {
        "id": 137,
        "title": "13MM"
    },
    {
        "id": 139,
        "title": "14MM"
    },
    {
        "id": 140,
        "title": "14/3MM"
    },
    {
        "id": 141,
        "title": "15MM"
    },
    {
        "id": 142,
        "title": "15/3MM"
    },
    {
        "id": 143,
        "title": "16MM"
    },
    {
        "id": 144,
        "title": "16/3MM"
    },
    {
        "id": 145,
        "title": "17MM"
    },
    {
        "id": 146,
        "title": "17/3MM"
    },
    {
        "id": 147,
        "title": "18MM"
    },
    {
        "id": 148,
        "title": "18/3MM"
    },
    {
        "id": 149,
        "title": "19MM"
    },
    {
        "id": 150,
        "title": "19/3MM"
    },
    {
        "id": 151,
        "title": "20MM"
    },
    {
        "id": 152,
        "title": "20/3MM"
    },
    {
        "id": 153,
        "title": "21MM"
    },
    {
        "id": 154,
        "title": "21/3MM"
    },
    {
        "id": 155,
        "title": "22MM"
    },
    {
        "id": 156,
        "title": "22/3MM"
    },
    {
        "id": 157,
        "title": "23MM"
    },
    {
        "id": 158,
        "title": "23/3MM"
    },
    {
        "id": 159,
        "title": "24MM"
    },
    {
        "id": 160,
        "title": "24/3MM"
    },
    {
        "id": 161,
        "title": "25MM"
    },
    {
        "id": 162,
        "title": "25/3MM"
    },

]